export const footer = {
    newsletter: {
        label: "S'abonner à la newsletter",
        inputLabels: {
            email: 'Adresse e-mail',
            next: 'Suivant',
            salutation: 'Titre',
            firstname: 'Prénom',
            lastname: 'Nom de famille',
            company: 'Entreprise',
            address: 'Adresse',
            postalCode: 'Code postal',
            city: 'Ville',
            privacyStatement: 'Déclaration de confidentialité',
            privacyStatementCheckbox:
                "J'accepte que Murtfeldt Additive Solutions traite mes données personnelles afin de répondre à ma demande. ",
            send: 'Envoyer',
        },
        requiredFieldsMissing: 'Certains champs obligatoires sont manquants',
    },
    socialMedia: {
        label: 'Suivez-nous sur',
    },
    legal: {
        label: 'Informations légales',
    },
    navigation: {
        reportBug: 'Signaler un bug',
    },
};
